import { useEffect, useState } from 'react';
import styles from './devicealertsmobile.module.css';
import moment from 'moment';

const DeviceAlertsMobile = ({ isPanelOpen, onToggle, deviceDetails }) => {
    const [alertList, setAlertList] = useState([]);

    useEffect(() => {
        if (deviceDetails?.device_alerts?.length > 0) {
            setAlertList(deviceDetails?.device_alerts);
        } else {
            setAlertList([]);
        }

    }, [deviceDetails]);

    return (<>
        <div className={`${styles.AccordionList}`}>
            <div className={`${styles.AccordionListHead} ${isPanelOpen === "seven" ? styles.Open : ""}`} onClick={() => onToggle("seven")}>
                <p className={`${styles.Title}`}>Device Alerts</p>
                <img src="/static/img/downTriangle.svg" alt="" />
            </div>
            <div className={`${styles.AccordionListBody} ${isPanelOpen === "seven" ? styles.Open : ""}`}>
                <div className={`${styles.TabBodySec}`}>
                    {alertList?.map(item => {
                        return <div className={`${styles.WorkOrderCard}`}>
                            {item?.title === "Water Leak" && (<div className={`${styles.CardAvatar} ${styles.Waterleak}`}>
                                <img src="/static/img/water-dash.svg" alt="" />
                            </div>)}

                            {item?.title === "Low Battery" && (<div className={`${styles.CardAvatar} ${styles.Lowbatter}`}>
                                <img src="/static/img/battery-dash.svg" alt="" />
                            </div>)}

                            {item?.title === "Device Offline" && (<div className={`${styles.CardAvatar} ${styles.Red}`}>
                                <img src="/static/img/wifi-dash.svg" alt="" />
                            </div>)}

                            {item?.title === "Device Online" && (<div className={`${styles.CardAvatar} ${styles.Green}`}>
                                <img src="/static/img/online.svg" alt="" />
                            </div>)}

                            {(item?.title?.toLowerCase().includes('door unlocked') || item?.title?.toLowerCase().includes('door is unlocked') || item?.title?.toLowerCase().includes('door was unlocked')) && (<div className={`${styles.CardAvatar} ${styles.Green}`}>
                                <img src="/static/img/lock-dash.svg" alt="" />
                            </div>)}


                            <div className={`${styles.CardDetails}`}>
                                <p className={`${styles.Title}`}>{item?.title}</p>
                                <p className={`${styles.SubTitle}`}>{moment.utc(item?.created_at).fromNow()}</p>
                            </div>
                        </div>
                    })}

                    {alertList?.length === 0 && (<div className={`${styles.NoDataMain}`}>
                        <div className={`${styles.NoDataIMG}`}>
                            <img src="/static/img/no-device.png" alt="No Data" />
                        </div>
                        <p className={`${styles.NoDataText}`}>Don't Worry!</p>
                        <p className={`${styles.NoDataTextSub}`}>Device Alerts is empty.</p>
                    </div>)}

                </div>
            </div>
        </div>
    </>)
}

export default DeviceAlertsMobile;